<template>
  <div class="document-apercu" :style="{ width: this.width + 'px' }">
    <b-loading :active="loading" :is-full-page="false" />

    <div class="resize" @mousedown="resizeMouseDown">
      <span />
    </div>

    <div :style="{ visibility: pageCount ? 'visible' : 'hidden' }" class="top">
      <template v-if="pageCount && pageCount > 1">
        <button :class="{ 'is-disabled': page === 1 }" class="button is-text" @click="prevPage">
          <b-icon icon="angle-left" />
        </button>
        <div class="page-count">{{ page }} / {{ pageCount }}</div>
        <button :class="{ 'is-disabled': page === pageCount }" class="button is-text" @click="nextPage">
          <b-icon icon="angle-right" />
        </button>
      </template>
      <button class="button is-text rotate" @click="rotateClick">
        <b-icon icon="undo" />
      </button>
      <button class="button is-text rotateleft" @click="rotateClickleft">
        <b-icon icon="undo" />
      </button>

      <button class="button is-text zoomIn" @click="zoomInClick">
        <b-icon icon="plus" />
      </button>
      <button class="button is-text zoomOut" @click="zoomOutClick">
        <b-icon icon="minus" />
      </button>

      <button v-if="allowDownload" class="button is-text" @click="download(details.name)">
        <b-icon icon="download" size="is-small" />
      </button>

      <button class="button is-text" @click="close">
        <b-icon icon="times" />
      </button>
    </div>
    <div class="preview" v-bind:style="{ transform: rotateProperty }">
      <canvas v-show="pageCount" ref="canvas" />

      <div v-if="!loading && !pageCount" class="pdf-only">
        <b-icon icon="eye-slash" pack="far" />
        <div>Aperçu non disponible</div>
      </div>
    </div>
    <div class="bottom">
      <template v-if="details">
        <div class="name">{{ details.name }}</div>
        <div class="size">{{ details.size }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import store from 'store'
import filesize from 'filesize'
// import { degrees, PDFDocument, rgb } from 'pdf-lib'
// PDF.js
import pdfjsLib from 'pdfjs-dist'
import MixinDownload from '@/mixins/Download'

let pdfDoc, canvas, ctx, isDL

export default {
  mixins: [MixinDownload],
  data () {
    return {
      isDL: this.$route.query.dl,
      loading: false,
      page: null,
      pageCount: null,
      width: store.get('apercu-width') || 500,
      rotateProperty: 'rotate(0deg)',
      isRotate: 0,
      scale: 1
    }
  },
  computed: {
    ...mapGetters({
      allowDownload: 'inv/allowDownload'
    }),
    ...mapGetters({
      filigraneActivated: 'inv/filigraneActivated'
    }),
    ...mapState(['user']),

    id () {
      if (!this.$route.query.invdoc) return 0
      return this.$route.query.invdoc.split('-')[0]
    },
    index () {
      if (!this.$route.query.invdoc) return 0
      return this.$route.query.invdoc.split('-')[1]
    },
    params () {
      let params = {}
      if (this.$route.params.portefeuille) {
        params.portefeuille = this.$route.params.portefeuille
      }
      if (this.$route.params.site) params.site = this.$route.params.site
      if (this.$route.params.bien) params.bien = this.$route.params.bien
      if (this.$route.query.an1) params.an1 = this.$route.query.an1
      if (this.$route.query.an2) params.an2 = this.$route.query.an2
      if (this.$route.query.an3) params.an3 = this.$route.query.an3
      if (this.$route.query.an4) params.an4 = this.$route.query.an4
      if (this.$route.query.an5) params.an5 = this.$route.query.an5
      if (this.$route.query.an6) params.an6 = this.$route.query.an6
      if (this.$route.query.an7) params.an7 = this.$route.query.an7
      if (this.$route.query.an8) params.an8 = this.$route.query.an8
      if (this.$route.query.an9) params.an9 = this.$route.query.an9
      params.user = this.getUser()
      params.addWatermark = this.filigraneActivated
      return params
    },
    details () {
      if (!this.$store.state.inv.documentsDetails[this.id]) {
        this.$store.dispatch('inv/getDocumentDetails', this.id)
        return null
      }
      const details = this.$store.state.inv.documentsDetails[this.id]
      if (details.files.length === 1) {
        return details
      }
      if (!details.files[this.index]) {
        return null
      }
      return {
        name: details.files[this.index].name,
        size: filesize(details.files[this.index].size),
        ext: details.files[this.index].ext
      }
    }
  },
  watch: {
    id () {
      this.getData()
    },
    index () {
      this.getData()
    },
    page () {
      this.renderPage()
    },
    isRotate () {
      this.renderPage()
    },
    scale () {
      this.renderPage()
    }
  },
  mounted () {
    this.getData()
    document.addEventListener('keydown', this.keyDownEvent)
    if (this.isDL) {
      this.close()
    }
  },
  destroyed () {
    document.removeEventListener('keydown', this.keyDownEvent)
  },
  methods: {
    /**
     * return the name of the active user
     */
    getUser () {
      return this.user !== null ? this.user.name : ''
    },
    /**
     * download file (with or without watermark)
     */
    download (Filename) {
      this.params.download = true
      console.log(
        3 +
        '.' +
        this.extension +
        ' ' +
        this.index +
        ' ' +
        JSON.stringify(this.params)
      )

      this.downloadDocument(this.id, this.index, this.params, Filename)
      // }
    },

    async getData () {
      this.loading = true
      this.page = null
      this.pageCount = null

      try {
        this.$store.dispatch('inv/getDocumentDetails', this.id)
      } catch (e) {
        this.apiError(e)
      }

      canvas = this.$refs.canvas
      ctx = canvas.getContext('2d')

      this.$store.dispatch('addDocument', this.id)
      // const url = this.documentUrl(this.id, this.index, this.params) + '&pdf'
      this.params['download'] = false
      const url = this.documentBase64(this.id, this.index, this.params) + '&pdf'

      try {
        pdfDoc = await pdfjsLib.getDocument(url).promise

        this.pageCount = +pdfDoc.numPages
        this.page = 1
        this.loading = false
      } catch (err) {
        console.log('err', err)
        this.loading = false
      }
    },

    calculateFontSizeDL (textLength, pageWidth) {
      const baseFontSize = 30 // Taille de police de base
      const maxWidthPercentage = 3 // Pourcentage de la largeur de la page pour la taille maximale

      // Calculer la taille de police en fonction de la longueur du texte et la largeur de la page
      const fontSize = Math.min(
        (pageWidth * maxWidthPercentage) / textLength,
        baseFontSize
      )

      return fontSize
    },

    /**
     * Document preview presentation
     */
    async renderPage () {
      const page = await pdfDoc.getPage(this.page)
      let viewport = page.getViewport({ scale: this.scale, rotation: 90 })

      // canvas width/height
      switch (this.isRotate) {
        case 0:
          viewport = page.getViewport({ scale: this.scale, rotation: 0 })

          break
        case 90:
          viewport = page.getViewport({ scale: this.scale, rotation: 90 })

          break
        case 180:
          viewport = page.getViewport({ scale: this.scale, rotation: 180 })

          break
        case 270:
          viewport = page.getViewport({ scale: this.scale, rotation: 270 })

          break
      }

      canvas.height = viewport.height
      canvas.width = viewport.width

      const renderCtx = {
        canvasContext: ctx,
        viewport
      }

      await page.render(renderCtx).promise
    },

    calculateFontSize (ctx, text) {
      // Vous pouvez ajuster ces valeurs selon vos préférences
      const baseFontSize = 30
      const maxWidth = 300 // Largeur maximale avant de réduire la taille de la police

      const textWidth = ctx.measureText(text).width

      if (textWidth <= maxWidth) {
        return baseFontSize // Pas besoin de réduire la taille
      } else {
        // Réduire la taille de la police en fonction de la longueur du texte
        return Math.floor((baseFontSize * maxWidth) / textWidth)
      }
    },

    prevPage () {
      if (this.page === 1) return
      this.page--
    },
    nextPage () {
      if (this.page === this.pageCount) return
      this.page++
    },
    close () {
      this.$router.push({
        query: { invdoc: undefined }
      })
    },
    keyDownEvent (ev) {
      switch (ev.keyCode) {
        case 27: // esc
          this.close()
          return false
        case 37: // left
          this.prevPage()
          return false
        case 39: // right
          this.nextPage()
          return false
      }
    },
    resizeMouseDown (ev) {
      const originalX = ev.screenX
      const originalWidth = Number(this.width)
      const handleMouseMove = ev => {
        const offset = ev.screenX - originalX
        this.width = originalWidth - offset
        store.set('apercu-width', this.width)
      }
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', ev => {
        document.removeEventListener('mousemove', handleMouseMove)
      })
    },
    rotateClick () {
      switch (this.isRotate) {
        case 0:
          this.isRotate = 90
          break
        case 90:
          this.isRotate = 180
          break
        case 180:
          this.isRotate = 270
          break
        case 270:
          this.isRotate = 0
          break
      }
    },
    rotateClickleft () {
      switch (this.isRotate) {
        case 0:
          this.isRotate = 270
          break
        case 90:
          this.isRotate = 0
          break
        case 180:
          this.isRotate = 90
          break
        case 270:
          this.isRotate = 180
          break
      }
    },
    zoomInClick () {
      this.scale = this.scale + 0.1
    },
    zoomOutClick () {
      this.scale = this.scale - 0.1
    }
  }
}
</script>

<style lang="scss" scoped>
.document-apercu {
  z-index: 999;
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  background: #fff;
  padding: 0 2em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .resize {
    position: absolute;
    top: 0;
    left: -12px;
    height: 100%;
    width: 12px;
    background: #f4f4f4;
    cursor: col-resize;

    span {
      position: absolute;
      top: 50%;
      left: 4px;
      height: 12px;
      width: 4px;
      border-right: 1px solid #ddd;
      border-left: 1px solid #ddd;
    }
  }

  .close {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    text-decoration: none;
    color: #555;

    .icon {
      font-size: 0.85em;
    }
  }

  .download {
    position: absolute;
    bottom: 1.5em;
    right: 1.5em;
  }

  .rotate {
    transform: scale(-1, 1);

    .icon {
      font-size: 0.8em;
    }
  }

  .rotateleft {
    .icon {
      font-size: 0.8em;
    }
  }
}

.top {
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0.5em;
  color: #555;

  .button {
    text-decoration: none;
    color: #555;
  }

  .page-count {
    padding: 0.5em 1em 0;
    font-size: 0.85em;
  }
}

.pdf-only {
  color: #eee;
  text-align: center;

  div {
    margin-top: 1em;
    font-size: 1.2em;
    font-weight: bold;
  }

  .icon {
    font-size: 4em;
  }
}

.preview {
  text-align: center;
  overflow: auto;
}

.bottom {
  font-size: 0.85em;
  margin-bottom: 1em;

  .name {
    font-weight: bold;
  }

  .size {
    color: #888;
  }
}
</style>
